import React from "react"
import { TextField } from "@mui/material"

const InputComponent = React.forwardRef((props, _) => <div {...props} />)

const OutlinedDiv = ({ children, label, size = "small", ...props }) => {
    return (
        <TextField
            variant="outlined"
            label={label}
            size={size}
            multiline
            InputLabelProps={{ shrink: true }}
            InputProps={{
                inputComponent: InputComponent
            }}
            inputProps={{ children }}
            {...props}
        />
    )
}

export default OutlinedDiv
